import useWarehouseImagesPreload from 'hooks/useWarehouseImagesPreload'
import { SkeletonTheme } from 'react-loading-skeleton'
import { LOCATION_STATES } from './utils/constants'
import { checkIsNativeApp } from 'utils/nativeApp'
import 'react-loading-skeleton/dist/skeleton.css'
import * as nativeApp from './utils/nativeApp'
import AppLogin from './containers/AppLogin'
import { isDay } from './utils/sunPosition'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { updateTheme } from './appSlice'
import './App.scss'

const App = ({ children }) => {
  const [isLogIn, logIn] = useState(!process.env.REACT_APP_PASSWORD || checkIsNativeApp())

  const dispatch = useDispatch()
  useWarehouseImagesPreload()

  useEffect(() => {
    if (nativeApp.checkIsNativeApp() && window.__NATIVE_APP__?.theme) {
      dispatch(updateTheme({
        mode: window.__NATIVE_APP__.theme.mode,
        lightTheme: window.__NATIVE_APP__.theme.value === 'light',
      }))
    } else {
      dispatch(updateTheme({ mode: 'auto', lightTheme: isDay() }))
    }
  }, [dispatch])

  useEffect(() => {
    const { href, origin } = window.location
    const homePath = `${origin}/`

    if (performance.getEntriesByType('navigation')[0].type !== 'reload') {
      window.history.replaceState(LOCATION_STATES.lastPage, null, homePath)
      window.history.pushState(null, '', homePath)
      window.history.pushState(null, '', href)
    }
  }, [])

  useEffect(() => {
    const popstate = () => {
      const { state } = window.history
      if (state === LOCATION_STATES.lastPage) window.history.go(1)
    }

    window.addEventListener('popstate', popstate)
    return () => {
      window.removeEventListener('popstate', popstate)
    }
  }, [])

  return (
    <div className={`app --${process.env.REACT_APP_TYPE || 'am'}${nativeApp.checkIsIos() ? ' --ios' : ''}`}>
      <SkeletonTheme
        baseColor='var(--skeleton-base)'
        highlightColor='var(--skeleton-highlight)' >
        {isLogIn ? children : <AppLogin login={logIn} />}
      </SkeletonTheme>
    </div>
  )
}

export default App
